<template lang="pug">
#app.flex.flex-column.vh-100.avenir
    #middle.flex.flex-auto
        #sidebar.br.b--light-gray.pt3.ph3.flex.flex-column(:class="{ collapseSidebar }")
            AddressBox(:boundaryYear="boundaryYear")
            Results.overflow-auto.flex-auto
        #map-container.relative.flex-auto
            Map(:boundaryYear="boundaryYear")
            #overlay.absolute
    #bottom.bt.b--light-gray.flex-none
</template>

<script>
import { EventBus } from './EventBus';
import Map from './components/Map.vue';
import FeatureInfo from './components/FeatureInfo.vue';
import AddressBox from './components/AddressBox.vue';
import Results from './components/Results.vue';
window.app = {};
window.app.lookupHost = '';
if (window.location.hash.match('tilesqa')) {
    window.app.lookupHost = 'http://schoolboundaries-qa.crowdspot.com.au';
} else if (window.location.host.match('localhost')) {
    window.app.lookupHost = 'http://localhost:4008';
}

window.app.tileHost = '';
if (window.location.hash.match(/tilesqa/)) {
    window.app.tileHost = 'https://schoolboundaries-qa.crowdspot.com.au';
} else if (window.location.hostname.match(/localhost/)) {
    window.app.tileHost = 'http://localhost:4001';
}

export default {
    name: 'app',
    components: {
        Map,
        FeatureInfo,
        AddressBox,
        Results,
    },
    data: () => ({
        collapseSidebar: false,
        boundaryYear: '2027',
    }),
    created() {
        window.app.App = this;
        EventBus.$on('select-dta', (boundary) => {
            this.collapseSidebar = true;
        });
        window.onhashchange = () => {
            console.log(window.location.hash);
            this.collapseSidebar = window.location.hash.match(/map/);
        };
    },
};

require('tachyons/css/tachyons.min.css');
</script>

<style>
html,
body {
    height: 100vh;
    width: 100%;
    margin: 0;
    padding: 0;
}
@font-face {
    font-family: VIC;
    src: url('./assets/VIC-SemiBold.otf') format('opentype');

    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: VIC;
    src: url('./assets/VIC-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: VIC;
    src: url('./assets/VIC-Light.otf') format('opentype');
    font-weight: 100;
}

#app {
    font-family: 'VIC', 'Avenir', Helvetica, Arial, sans-serif;
    font-weight: normal;
}

#sidebar {
    min-width: 200px;
    width: 100%;
}

#results-button {
    display: none;
}

@media screen and (min-width: 768px) {
    #sidebar {
        width: 400px;
    }
}
@media screen and (max-width: 767px) {
    #sidebar.collapseSidebar {
        display: none;
    }
    #results-button.show {
        display: block;
        position: absolute;
        transition: background-color 0.3s ease;
        box-sizing: border-box;
        color: #333;
    }
    #results-button.show:hover {
        background: hsl(220, 80%, 85%);
        color: #000;
        /* font-weight:500; */
    }

    #results-button {
        text-decoration: none;
    }
}
</style>
